/**
 * Shown while a lazy route module is still loading, including on the very first
 * paint. React Router warns if a data router has no hydrate fallback.
 *
 * Skeleton blocks at content dimensions, not a spinner: keeps the layout stable
 * (MASTER.md §9).
 */
export function RouteFallback() {
  return (
    <div className="flex flex-col gap-4" role="status" aria-busy="true">
      <span className="sr-only">Загрузка</span>
      <div className="h-8 w-2/3 rounded-md bg-muted" />
      <div className="h-4 w-full rounded-md bg-muted" />
      <div className="h-4 w-5/6 rounded-md bg-muted" />
      <div className="h-24 w-full rounded-xl bg-muted" />
      <div className="h-24 w-full rounded-xl bg-muted" />
    </div>
  )
}
